import { Component, OnInit } from "@angular/core";
import { E } from "@angular/material/error-options.d-CGdTZUYk";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { CrudService } from "src/app/Services/crud.service";

@Component({
  selector: "app-tokenexpired",
  templateUrl: "./token-expired.component.html",
  standalone: false,
})
export class TokenExpiredComponent implements OnInit {
  id: string;
  token;
  displayMessage;
  // APIURL: string = "https://config.theappsherpa.com";
  APIURL: string = "https://config.theappsherpa.com/";

  constructor(
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private crudService: CrudService,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
    // this.tokenExpired(this.token)
  }
  private tokenExpired(token: string) {
    const expiry = JSON.parse(atob(token.split(".")[1])).exp;
    return Math.floor(new Date().getTime() / 1000) >= expiry;
  }
  ngOnInit() {
    var self = this;
    this.route.queryParams.subscribe((params) => {
      const redirectEncoded = params["redirect"];
      if (!redirectEncoded) {
        this.toastr.error("Redirect URL missing.");
        return;
      }

      const redirectDecoded = decodeURIComponent(redirectEncoded);
      const queryString = redirectDecoded.split("?")[1]; // get only the part after ?
      const redirectParams = new URLSearchParams(queryString);

      this.token = redirectParams.get("token"); // ✅ Extract token from inside redirect
      this.id = redirectParams.get("uid"); // ✅ Extract uid from inside redirect

      if (!this.token || !this.id) {
        this.toastr.error("Missing token or UID in redirect URL.");
        return;
      }

      // Continue with your logic (API call, message, redirect, etc.)
    });

    this.crudService.get(
      null,
      function (response, error) {
        if (error) {
          self.toastr.clear();
          self.toastr.error("Something went wrong! Please try again.");
        } else {
          if (response == null || response == undefined) {
            self.displayMessage = `Verification successful! Your password has been set — you'll be redirected to the login page in 5 seconds, or you can click <strong style="font-size: 18px;"> <a href="${self.APIURL}">Login</a> </strong> to proceed now.`;
            setTimeout(() => {
              self.router.navigateByUrl(self.APIURL);
            }, 5000);
          } else if (response.error) {
            var errorObj = response.error;
            if (errorObj.error.code === "INVALID_TOKEN") {
              self.displayMessage = `This token is expired. Alternatively, you can use <a href="${self.APIURL}/forgot-password">Recover Password</a> functionality to recover.`;
            } else if (errorObj.error.code === "INVALID_USER") {
              self.displayMessage = `User cannot be found`;
            } else {
              return errorObj.error.code;
            }
          }
        }
      },
      "userManagements/confirm?uid=" + this.id + "&token=" + this.token
    );
  }
}
